export const REPORTDECLARATIONS_SEARCH = 'REPORTDECLARATIONS_SEARCH';
export const REPORTDECLARATIONS_PAGE = 'REPORTDECLARATIONS_PAGE';
export const REPORTDECLARATIONS_STARTDATE = 'REPORTDECLARATIONS_STARTDATE';
export const REPORTDECLARATIONS_ENDDATE = 'REPORTDECLARATIONS_ENDDATE';
export const REPORTDECLARATIONS_USER = 'REPORTDECLARATIONS_USER';
export const REPORTDECLARATIONS_COUNTRY = 'REPORTDECLARATIONS_COUNTRY';
export const REPORTDECLARATIONS_STATUS = 'REPORTDECLARATIONS_STATUS';
export const REPORTDECLARATIONS_THREEPSUPPLIER = 'REPORTDECLARATIONS_THREEPSUPPLIER';